export const PERMISSIONS = {
  BLOCK_CONTACTS: {
    CREATE: "block_contacts.create",
    EDIT: "block_contacts.edit",
    DELETE: "block_contacts.delete",
    VIEW: "block_contacts.view",
    DOWNLOAD: "block_contacts.download",
  },

  DASHBOARD: {
    VIEW: "dashboard.view",
  },

  CAMPAIGN: {
    CREATE: "campaign.create",
    EDIT: "campaign.edit",
    DELETE: "campaign.delete",
    VIEW: "campaign.view",
    DOWNLOAD: "campaign.download",
  }, //campaign query

  CAMPAIGN_AUDIENCE: {
    CREATE: "campaign_audience.create",
    EDIT: "campaign_audience.edit",
    DELETE: "campaign_audience.delete",
    VIEW: "campaign_audience.view",
    DOWNLOAD: "campaign_audience.download",
  },

  IVR_EXCLUDE_CONTACTS: {
    CREATE: "ivr_exclude_contacts.create",
    EDIT: "ivr_exclude_contacts.edit",
    DELETE: "ivr_exclude_contacts.delete",
    VIEW: "ivr_exclude_contacts.view",
    DOWNLOAD: "ivr_exclude_contacts.download",
  },

  USERS: {
    CREATE: "users.create",
    EDIT: "users.edit",
    DELETE: "users.delete",
    VIEW: "users.view",
    DOWNLOAD: "users.download",
  },

  TEMPLATES: {
    CREATE: "templates.create",
    EDIT: "templates.edit",
    DELETE: "templates.delete",
    VIEW: "templates.view",
    DOWNLOAD: "templates.download",
  },

  JOB_LIST: {
    CREATE: "job_list.create",
    EDIT: "job_list.edit",
    DELETE: "job_list.delete",
    VIEW: "job_list.view",
    DOWNLOAD: "job_list.download",
  },

  EMAIL_CAMPAIGN_REPORT: {
    CREATE: "email_campaign_report.create",
    EDIT: "email_campaign_report.edit",
    DELETE: "email_campaign_report.delete",
    VIEW: "email_campaign_report.view",
    DOWNLOAD: "email_campaign_report.download",
  },

  SMS_CAMPAIGN_REPORT: {
    CREATE: "sms_campaign_report.create",
    EDIT: "sms_campaign_report.edit",
    DELETE: "sms_campaign_report.delete",
    VIEW: "sms_campaign_report.view",
    DOWNLOAD: "sms_campaign_report.download",
  },

  IVR_CAMPAIGN_REPORT: {
    CREATE: "ivr_campaign_report.create",
    EDIT: "ivr_campaign_report.edit",
    DELETE: "ivr_campaign_report.delete",
    VIEW: "ivr_campaign_report.view",
    DOWNLOAD: "ivr_campaign_report.download",
  },

  EMAIL_SUPPRESSION_LIST: {
    CREATE: "email_suppression_list.create",
    EDIT: "email_suppression_list.edit",
    DELETE: "email_suppression_list.delete",
    VIEW: "email_suppression_list.view",
    DOWNLOAD: "email_suppression_list.download",
  },

  ROLES_MANAGEMENT: {
    CREATE: "roles_management.create",
    EDIT: "roles_management.edit",
    DELETE: "roles_management.delete",
    VIEW: "roles_management.view",
    DOWNLOAD: "roles_management.download",
  },

  PERMISSIONS_MANAGEMENT: {
    CREATE: "permission_management.create",
    EDIT: "permission_management.edit",
    DELETE: "permission_management.delete",
    VIEW: "permission_management.view",
    DOWNLOAD: "permission_management.download",
  },

  IP_MANAGEMENT: {
    CREATE: "ip_management.create",
    EDIT: "ip_management.edit",
    DELETE: "ip_management.delete",
    VIEW: "ip_management.view",
    DOWNLOAD: "ip_management.download",
  },

  EMAIL_VENDOR: {
    CREATE: "email_vendor.create",
    EDIT: "email_vendor.edit",
    DELETE: "email_vendor.delete",
    VIEW: "email_vendor.view",
    DOWNLOAD: "email_vendor.download",
  },

  EMAIL_CATEGORY: {
    CREATE: "email_category.create",
    EDIT: "email_category.edit",
    DELETE: "email_category.delete",
    VIEW: "email_category.view",
    DOWNLOAD: "email_category.download",
  },

  GLOBAL_SETTING: {
    VIEW: "global_setting.view",
    EDIT: "global_setting.edit",
  },

  SMART_CONNECT: {
    CREATE: "smart_connect.create",
    EDIT: "smart_connect.edit",
    DELETE: "smart_connect.delete",
    VIEW: "smart_connect.view",
    DOWNLOAD: "smart_connect.download",
  },

  VI_CTS: {
    CREATE: "vi_cts.create",
    EDIT: "vi_cts.edit",
    DELETE: "vi_cts.delete",
    VIEW: "vi_cts.view",
    DOWNLOAD: "vi_cts.download",
  },

  PRE_LEADS: {
    CREATE: "pre_leads.create",
    EDIT: "pre_leads.edit",
    DELETE: "pre_leads.delete",
    VIEW: "pre_leads.view",
    DOWNLOAD: "pre_leads.download",
  },

  LEADS_DATA_TRANSFER_SETTING: {
    CREATE: "leads_data_transfer_setting.create",
    EDIT: "leads_data_transfer_setting.edit",
    DELETE: "leads_data_transfer_setting.delete",
    VIEW: "leads_data_transfer_setting.view",
    DOWNLOAD: "leads_data_transfer_setting.download",
  },
};
